import toggle from './toggle';

export default {
  toggle,
};



// WEBPACK FOOTER //
// ./src/actions/boolean/index.js